export const WORK_ORDER_TABS = {
  ROUTING: 'Routing',
  CONTAINERS: 'Containers',
  EXCEPTIONS: 'Exceptions',
  ACTIVITY: 'Activity',
}
